import { Button, Grid } from "@mui/material";
import "./headerbar.scss";
import SearchIcon from "@mui/icons-material/Search";
import { useEffect, useState } from "react";
import profile_image from "../../../assets/images/2.jpg";
import SimpleDialog from "../dialog/dialog";
import { useNavigate } from "react-router-dom";
import toaster from "../../../utility/toaster/toaster";
// import SideBarContext from "../../context/sidebarOpen/SidebarContext";
import debounce from "lodash/debounce";
import LogoutIcon from "@mui/icons-material/Logout";
import axios from "axios";

export default function Headerbar({
  searchFlag,
  allRowData,
  setAllRowFilteredData,
  setSearchVal,
  card,
  onUserRoleNameChange,
}) {
  const [open, setOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [username, setUsername] = useState("");
  const [profileImageSrc, setProfileImageSrc] = useState(null);
  const [clearedAppData, setClearedAppData] = useState(false); // Track if clearAllAppData() is executed

  const navigate = useNavigate();
  //Logout Functionality
  function clearAllAppData() {
    if (!clearedAppData) {
      // Clear cookies
      document.cookie.split(";").forEach((cookie) => {
        const name = cookie.split("=")[0].trim();
        let domain = "";

        if (
          process.env.REACT_APP_ENV === "production" ||
          process.env.REACT_APP_ENV === "test"
        ) {
          // Production & Test environment
          domain = "; domain=.pharmaaceapps.com";
        }

        document.cookie =
          name + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/" + domain;
      });

      localStorage.clear();
      sessionStorage.clear();

      // Clear IndexedDB
      indexedDB.databases().then((databases) => {
        databases.forEach((db) => {
          indexedDB.deleteDatabase(db.name);
        });
      });

      setClearedAppData(true); // Ensure this runs only once
    }
  }

  // Function to check if user is authenticated and redirect accordingly
  const checkAuthentication = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL_LOGIN_APP}/auth/check-token`,
        {
          method: "GET",
          credentials: "include", // Include cookies in the request
        }
      );

      if (response.ok) {
        // stay on ApplicationPage page
      } else {
        clearAllAppData();
        navigate("/login");
        console.error("Not Logged in");
      }
    } catch (error) {
      clearAllAppData();
      console.error("Error during logout:", error);
    }
  };

  const handleLogoutClick = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL_LOGIN_APP}/auth/logout`,
        {
          method: "POST",
          credentials: "include", // Include cookies in the request
        }
      );

      if (response.ok) {
        toaster("success", "Logged out Successfully");
        navigate("/login");
      } else {
        // Handle logout error if needed
        console.error("Logout failed");
      }
    } catch (error) {
      // Handle network or fetch errors
      console.error("Error during logout:", error);
    }
  };

  const getUserDetails = async () => {
    // Set CORS-related headers
    const config = {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": `${process.env.REACT_APP_BACKEND_URL_LOGIN_APP}`,
        "Access-Control-Allow-Credentials": "true",
      },
      withCredentials: true, // This is important to include cookies in requests
    };
    axios
      .get(
        `${process.env.REACT_APP_BACKEND_URL_LOGIN_APP}/auth/user-details`,
        config
      )
      .then((res) => {
        let userDetails = res?.data;
        setUsername(userDetails.username);
        const userRoleName = userDetails.role_id;
        onUserRoleNameChange(userRoleName);
        console.log("eeeeeeeeee", userDetails);
        // const profileImage = userDetails?.img_url  ? `data:image/png;base64,${params.value}` : "/profile-image.png";
        // If userDetails contains img_url, set the image source with the Base64 string
        if (userDetails.img_url) {
          const base64Image = `data:image/png;base64,${userDetails.img_url}`; // Assuming PNG, adjust type if needed
          setProfileImageSrc(base64Image);
        } else {
          const profileImage = "/profile-image.png";
          setProfileImageSrc(profileImage);
        }
      })
      .catch((error) => {
        console.log("Error fetching applications : ", error);
      });
  };

  const handleSearchChange = (event) => {
    const searchTerm = event.target.value;
    console.log("called");
    setSearchTerm(searchTerm);
    setSearchVal(searchTerm);

    const debouncedSearch = debounce((searchTerm) => {
      const filteredData = allRowData?.filter((item) =>
        Object.values(item).some(
          (value) =>
            value &&
            value.toString().toLowerCase().includes(searchTerm.toLowerCase())
        )
      );
      setAllRowFilteredData(filteredData);
    }, 200);
    debouncedSearch(searchTerm);
  };

  useEffect(() => {
    checkAuthentication();
    getUserDetails();
    if (searchTerm) {
      const filteredData = allRowData?.filter((item) =>
        Object.values(item).some(
          (value) =>
            value &&
            value.toString().toLowerCase().includes(searchTerm.toLowerCase())
        )
      );
      setAllRowFilteredData(filteredData);
    }
  }, [card, allRowData, searchTerm, setAllRowFilteredData]);

  return (
    <>
      <Grid
        container
        className="header-main"
        style={
          searchFlag
            ? { justifyContent: "space-between" }
            : { justifyContent: "flex-end", paddingRight: "0px" }
        }
      >
        {/* <Grid direction="column" className="header-subgrid">
          <h3>{title}</h3>
          <span>{date}</span>
        </Grid> */}
        {searchFlag && (
          <Grid className="search-bar" alignItems={"center"}>
            <Grid className="search-box">
              <Grid>
                {/* <SmartToyIcon /> */}
                <i className="fa-solid fa-robot"></i>
                <input
                  placeholder="Hey! What can I help you with?"
                  className="search"
                  autoComplete="off"
                  onChange={handleSearchChange}
                  autoCapitalize="off"
                  autoFocus="off"
                  type="text"
                  value={searchTerm}
                  name="search"
                ></input>
              </Grid>
              {/* <SearchBar /> */}
              <SearchIcon fontSize="small" />
            </Grid>
          </Grid>
        )}
        <Grid className="profile-div">
          <Grid className="sidebar-footer">
            <Grid className="menu-div">
              <span>{username}</span>
              <img
                src={profileImageSrc}
                alt="profile_image"
                style={{ cursor: "pointer" }}
              ></img>
              <LogoutIcon
                style={{ cursor: "pointer", fontSize: "30px" }}
                onClick={() => setOpen(true)}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <SimpleDialog
        open={open}
        setOpen={setOpen}
        content={
          <Grid className="logout-main">
            <span>Are you sure you want to Logout?</span>
            <Grid>
              <Button onClick={handleLogoutClick}>Yes</Button>
              <Button onClick={() => setOpen(false)}>Cancel</Button>
            </Grid>
          </Grid>
        }
        executeFlag={false}
      />
    </>
  );
}
